(function () {
  'use strict';

  BrandCtrl.$inject = ['$scope', 'resolveData', 'brandModel', 'brandResource', 'publicPagesPro', 'publicPagesBasic', '$timeout', '$q', 'Validation', '$rootScope', '$location', 'mtypes', 'accountFeatures', 'accountInfoService', 'logoResource'];
  angular
    .module('branding')
    .controller('BrandCtrl', BrandCtrl);

  function BrandCtrl($scope, resolveData, brandModel, brandResource, publicPagesPro, publicPagesBasic, $timeout, $q,
                     Validation, $rootScope, $location, mtypes, accountFeatures, accountInfoService, logoResource) {
    setBrandModel(brandModel, resolveData);

    var startPercent = '5';
    var inProgressPercent = '75';
    var completePercent = '100';

    $scope.customBranding = resolveData.customBranding;
    $scope.bodyColorOptions = brandModel.getBodyColorOptions();
    $scope.viewBrandModel = getViewModel(brandModel);
    $scope.viewBrandModel.showLogo = brandModel.isValidLogo();
    $scope.viewBrandModel.showHeaderColor = true;
    $scope.publicPages = publicPagesPro;
    $scope.pageColor = '';
    $scope.numOfPages = 5;

    setColorFeatures();

    $scope.changePages = function (color) {
      $scope.pageColor = (_.findWhere($scope.bodyColorOptions, { color: color })).name;
    };

    $scope.carouselOptions = {
      wrap: null,
      vertical: false,
      scroll: 0,
      animation: 200,
      buttonNextHTML: null,
      buttonPrevHTML: null
    };

    Validation.addValidation(validate);

    var nextLocation;

    function validate() {
      if (!$scope.isDirty)
        return true;

      nextLocation = $rootScope.newLocation.next;
      $scope.$broadcast('showUnsavedChanges', {
        cancelEventName: 'cancelSelection',
        leaveEventName: 'leaveSelection',
        text: 'By leaving this page, your changes will be lost. Are you sure you want to continue?',
        title: 'Unsaved Changes',
        leaveButtonTitle: 'Yes',
        cancelButtonTitle: 'No'
      });
      return false;
    }

    $scope.$on('cancelSelection', angular.noop);

    $scope.$on('leaveSelection', function () {
      $scope.isDirty = false;
      $location.path(nextLocation.path);
      nextLocation = null;
    });

    $scope.$on('$destroy', function () {
      Validation.removeValidation(validate);
    });

    $scope.reset = function () {
      $scope.viewBrandModel = getViewModel(brandModel);
      setColorFeatures();
    };

    $scope.apply = function () {
      var deferred = $q.defer();
      var filename = $scope.viewBrandModel.companyInfo.logoFileName;
      var fileUrl = $scope.viewBrandModel.companyInfo.logoUrl;

      if (filename && fileUrl) {
        $scope.percent = startPercent;
        var logoResourcePromise = logoResource.create({ filename: filename, fileUrl: fileUrl }).$promise;
        logoResourcePromise.then(function (result) {
          $scope.percent = inProgressPercent;
          $scope.viewBrandModel.companyInfo.logoFileId = result.contentFileId;
          var params = getParams($scope.viewBrandModel);
          if (params) {
            var brandResourcePromise = brandResource.update(params).$promise;
            brandResourcePromise.then(function (result) {
              $scope.percent = completePercent;
              setBrandModel(brandModel, result);
              $scope.viewBrandModel = getViewModel(brandModel);
              setColorFeatures();
              $timeout(function () {
                $scope.percent = '';
                deferred.resolve();
              }, 1000);
            });
          } else {
            deferred.resolve();
          }
        });
      } else {
        $scope.percent = startPercent;
        var params = getParams($scope.viewBrandModel);
        if (params) {
          var brandResourcePromise = brandResource.update(params).$promise;
          brandResourcePromise.then(function (result) {
            $scope.percent = completePercent;
            setBrandModel(brandModel, result);
            $scope.viewBrandModel = getViewModel(brandModel);
            setColorFeatures();
            $timeout(function () {
              $scope.percent = '';
              deferred.resolve();
            }, 1000);
          });
        } else {
          deferred.resolve();
        }
      }

      return deferred.promise;
    };

    $scope.showFeatureUpgrade = function () {
      accountInfoService.openNewWindow();
    };

    function getParams(viewBrandModel) {
      var params = {};
      var colorScheme = (_.findWhere($scope.bodyColorOptions, { color: viewBrandModel.bodyColor }) || $scope.bodyColorOptions[0]).mtype;

      if (viewBrandModel.bodyColor !== brandModel.selectedBodyColor) {
        params.colorScheme = colorScheme;
      }

      if (viewBrandModel.headerColor.background !== brandModel.selectedHeaderBackgroundColor) {
        params.headerBackgroundColor = viewBrandModel.headerColor.background;
      }

      if (viewBrandModel.headerColor.text !== brandModel.selectedTextColor) {
        params.headerTextColor = viewBrandModel.headerColor.text;
      }

      if (viewBrandModel.headerColor.link !== brandModel.selectedLinkColor) {
        params.headerLinkColor = viewBrandModel.headerColor.link;
      }

      if (viewBrandModel.companyInfo.name !== brandModel.name) {
        params.name = viewBrandModel.companyInfo.name;
      }

      if (viewBrandModel.companyInfo.description !== brandModel.description) {
        params.description = viewBrandModel.companyInfo.description;
      }

//      if(viewBrandModel.companyInfo.logoUrl != brandModel.logoUrl) {
//        params.logoUrl = viewBrandModel.companyInfo.logoUrl;
//      }

      if (viewBrandModel.companyInfo.logoFileId !== brandModel.logoFileId) {
        params.logoFileId = viewBrandModel.companyInfo.logoFileId;
      }

      if (viewBrandModel.companyInfo.logoStatus !== brandModel.logoStatus) {
        params.logoStatus = viewBrandModel.companyInfo.logoStatus;
      }

      if (viewBrandModel.companyInfo.logoFileName) {
        params.logoFileName = viewBrandModel.companyInfo.logoFileName;
      }

      if (_.isEmpty(params)) {
        return;
      }

      _.defaults(params, {
        name: viewBrandModel.companyInfo.name,
        colorScheme: colorScheme,
        logoStatus: viewBrandModel.companyInfo.logoStatus,
        description: viewBrandModel.companyInfo.description,
        headerBackgroundColor: viewBrandModel.headerColor.background,
        headerTextColor: viewBrandModel.headerColor.text,
        headerLinkColor: viewBrandModel.headerColor.link
      });

      return params;
    }

    function setBrandModel(model, data) {
      model.setName(data.name);
      model.setDescription(data.description);
      model.setLogoUrl(data.logoUrl);
      model.setLogoFileId(data.logoFileId);
      model.setSelectedBodyColor(data.colorScheme);
      model.setHeaderBackgroundColor(data.headerBackgroundColor);
      model.setHeaderTextColor(data.headerTextColor);
      model.setHeaderLinkColor(data.headerLinkColor);
    }

    function getViewModel(fromBrandModel) {
      return {
        showHeaderColor: true,
        bodyColor: fromBrandModel.selectedBodyColor,
        companyInfo: {
          logoStatus: 'unchanged',
          logoUrl: fromBrandModel.logoUrl,
          logoFileId: fromBrandModel.logoFileId,
          logoFileName: '',
          name: fromBrandModel.name,
          description: fromBrandModel.description
        },
        headerColor: {
          background: fromBrandModel.selectedHeaderBackgroundColor,
          text: fromBrandModel.selectedTextColor,
          link: fromBrandModel.selectedLinkColor
        }
      };
    }

    function haveColorFeature() {
      return ~accountFeatures.features.indexOf(mtypes.featureEntry.customBranding);
    }

    function setColorFeatures() {
      if (haveColorFeature()) {
        return;
      }

      _.each($scope.bodyColorOptions, function (model) {
        if (model.mtype === 0) {
          model.disabled = true;
        }
      });

      $scope.viewBrandModel.showHeaderColor = true; // show this anyway for preview purposes
      $scope.viewBrandModel.headerColor.showCustomBrandingPreview = true;

      $scope.publicPages = publicPagesBasic;
      $scope.numOfPages = 4;
    }
  }
})();
